<template>
    <el-row :gutter="20" class="panel">
        <div class="panel-border" style="margin: 0 0 16px 0;"></div>
        <!-- 第一个统计项：修复@click绑定、key、数值渲染 -->
        <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6" class="panel-col" v-for="item in titleDataList"
            :key="item.key" :style="{ borderRight: item.key === 'signCount' ? 'none' : '1px solid #e5e6eb' }">
            <!-- 核心修复：把@click移到内部独立div，避免v-for作用域歧义，确保事件触发 -->
            <div class="col-content" @click="toPage(item.pageUrl)">
                <el-row type="flex" align="center" :gutter="12">
                    <el-avatar :size="54" class="col-avatar">
                        <img alt="avatar" :src="item.imgUrl" />
                    </el-avatar>
                    <div class="statistic-wrap">
                        <div class="statistic-title">{{ item.title }}</div>
                        <div class="statistic-value">
                            <!-- 修复：从dataVal（父组件传的对象）取值，不是titleDataList数组 -->
                            <span class="number">{{ dataVal[item.key] || 0 }}</span>
                        </div>
                    </div>
                </el-row>
            </div>
        </el-col>
        <!-- 分割线 -->
        <el-col :span="24">
            <el-divider class="panel-border" />
        </el-col>
    </el-row>
</template>

<script>
export default {
    name: 'WorkplaceStatisticPanel',
    props: {
        // 注意：父组件传的dataVal是**对象**（如{regUserCount: 100, circleCount: 20}），不是数组！原props定义错误
        dataVal: {
            type: Object,  // 修复：从Array改为Object，匹配实际传值
            default: () => ({})
        },
        titleDataList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {}
    },
    methods: {
        toPage(url) {
            console.log('触发toPage：', url);
            // 增加空值提示，方便调试
            if (!url) {
                this.$message?.warning('暂无跳转地址');
                return;
            }
            // 兼容Vue2的$router.push（字符串/对象都支持）
            this.$router.push(url);
        }
    }
}
</script>

<style lang="scss" scoped>
// 整体面板样式
.panel {
    margin-bottom: 0;
    padding: 20px;
}

// 列样式：移除cursor，把点击相关样式移到内部col-content
.panel-col {
    padding: 16px;
    box-sizing: border-box;
    padding-left: 30px !important;

    // 适配移动端，在小屏幕下调整样式
    @media (max-width: 768px) {
        padding: 12px 16px;
        border-right: none;
        border-bottom: 1px solid #e5e6eb;

        &:last-child {
            border-bottom: none;
        }
    }
}

// 核心：独立的点击容器，解决v-for作用域歧义，统一点击样式
.col-content {
    width: 100%;
    height: 100%;
    cursor: pointer;
    transition: all 0.2s ease;

    // 点击hover/active样式，增加反馈
    &:hover {
        transform: scale(1.02);
    }

    &:active {
        transform: scale(0.98);
    }
}

// 头像样式
.col-avatar {
    margin-right: 16px;
    background-color: #f5f7fa; // 对应 var(--color-fill-2)
}

// 统计项容器
.statistic-wrap {
    flex: 1;
}

// 统计标题
.statistic-title {
    font-size: 14px;
    color: #4e5969;
    margin-bottom: 6px;
    line-height: 1.4;
}

// 统计数值
.statistic-value {
    .number {
        font-size: 28px;
        font-weight: 600;
        color: #1d2129;
        line-height: 1.2;
    }

    .suffix {
        margin-left: 6px;
        font-size: 16px;
        color: #4e5969;
        line-height: 1.2;
    }

    .unit {
        margin-left: 10px;
        color: #86909c; // 对应 var(--gray-8)
        font-size: 14px;
    }
}

// 上升图标样式
.up-icon {
    color: #e54d42; // 对应 var(--red-6)
    font-size: 16px;
    margin-left: 4px;
    vertical-align: middle;
}

// 分割线样式
::v-deep(.panel-border) {
    margin: 16px 0 0 0;
    background-color: #e5e6eb;
    height: 1px;
}
</style>